import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import CardSpacer from '../../components/CardSpacer/CardSpacer';
import PageHeading from '../../components/PageHeading/PageHeading.js';
import BackLink from '../../components/BackLink/BackLink';
import withBaseLayout from '../../components/BaseLayout/withBaseLayout';
import ButtonRadioField from '../../components/Fields/ButtonRadioField/ButtonRadioField';

import styles from './styles.js';
import { withStyles } from '@material-ui/core/styles';

function WorkRequestsChildLayout(props) {
  const {
    classes,
    title,
    currentFilter,
    filterAction,
    filters,
    requests,
    backAction,
  } = props;

  const filterOptions = [];

  filters.map((filter, index) => {
    filterOptions.push({ value: filter.filterValue, label: filter.label });
  });

  return (
    <div className={`${classes.root} PageLayout`}>
      <BackLink action={backAction} />
      <PageHeading heading={title} />
      {filterOptions.length && filterAction ? (
        <div className={classes.filterContainer}>
          <ButtonRadioField
            fieldName={'filter'}
            value={currentFilter}
            onChange={(event) => {
              filterAction(event.target.value);
            }}
            options={filterOptions}
          />
        </div>
      ) : null}
      <Grid container spacing={24} className="DashGridContainer">
        <Grid item xs={12} className={`DashGridColumn ${classes.gridColumn}`}>
          {requests.map((request, index) => {
            return (
              <div className={classes.requestHolder} key={index}>
                {request}
              </div>
            );
          })}
        </Grid>
      </Grid>
      <BackLink action={backAction} gutterTop={true} />
    </div>
  );
}

WorkRequestsChildLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  currentFilter: PropTypes.string,
  filterAction: PropTypes.func,
  filters: PropTypes.array,
  requests: PropTypes.array,
  backAction: PropTypes.func.isRequired,
};

WorkRequestsChildLayout.defaultProps = {
  currentFilter: null,
  filterAction: null,
  filters: [],
  requests: [],
};

export default withBaseLayout(withStyles(styles)(WorkRequestsChildLayout));
